export default (flag: string): boolean => (
  flag === null || flag === undefined || `${flag}`.toLowerCase() === 'true'
);
